import React from 'react';
import moment from 'moment-jalaali';
import { smartSplitDateAndTimeDuration } from 'utils/date';

import {
  black,
  blue,
  gray,
  green,
  red,
  exactWhite,
  stringToColour,
  orange,
  lightGreenSolid,
} from 'utils/style/colors';
import generateUserPermission from 'utils/permission';
import {
  convertDigitToProperFormat,
  convertNumbersToProperFormat,
} from 'utils/number';
import * as taskManipulate from 'store/tasks/taskManipulate';

import messages from './Messages';
import taskMessages from '../../containers/Tasks/TasksManagement/Messages';
import {
  ItemWrapper,
  Progress,
  TaskItem,
  TaskItemBody,
  TaskTitle,
  DateContainer,
  TaskTitleText,
  BadgeGroup,
  TaskBadge,
  ItemContianer,
  BadgeItemWrapper,
  TaskBadgePopOverTaskList,
  MiniBadgeItemWrapper,
  MiniItemWrapper,
  MiniTaskItemBody,
  MiniContentItem,
  TaskBadgeContent,
  MiniContentText,
  MinDateContainer,
} from './styles';
import TaskUserList from '../UserSelector/TaskUserList';
import { IUserOption } from '../UserSelector/UserSelector';
import { connect, MapStateToProps } from 'react-redux';
import { appDispatch, IUsers, RootState } from 'store/store';
import APopover from 'components/APopover';
import { ChipContainer } from '../Chip/Chip';
// import AssigneeChip from '../AssigneeChip/AssigneeChip';
import Badge from '../Badge/Badge';
import { Draggable } from 'react-beautiful-dnd';
import MentionPop from '../MentionPop/MentionPop';
import { withMutipleTitle, withTitle } from '../withTitle';
import { roundToDynamicFloating } from '../Chart/analyseUtils';
import {
  HiddenFieldValue,
  IAssignmentView,
  IField,
  ITask,
  TaskStatus,
} from 'store/tasks/tasksType';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import {
  IProjectMemberView,
  IProjectStore,
} from 'store/companies/companiesTypes';
import Button from '../Button';
import Input from '../Input';
import cloneDeep from 'lodash/cloneDeep';
import {
  isCompanyAdmin,
  isCompanyOwnerOrSupport,
} from '../../store/companies/companiesUtils';
import ProgressBar from 'components/ProgressBar';
import { WithTranslation, withTranslation } from 'react-i18next';
import { languageDirection } from '../../i18n';
import { updateTask } from '../../store/tasks/tasksSlice';

moment.loadPersian({ dialect: 'persian-modern' });
export type WindowSize = 'large' | 'medium' | 'small';
interface IOwnProps {
  task: ITask;
  active?: boolean;
  template: ITask;
  thisUser: IThisUserState;
  companyId?: number;
  thisUserId: number;
  projectId?: number;
  showWeight?: boolean;
  onUpdateTask: (taskView: ITask) => void;
  showProgress: boolean;
  onClickOnTask: {
    (taskId: number, tab: string, token?: string, e?: React.MouseEvent): void;
    (e: any): void;
  };
  companyOwnerId: number;
  templateSelected?: boolean;
  onUpdateAssignment?: (assigneeView: IAssignmentView) => void;
  index: number;
  isHomePage?: boolean;
  editable?: boolean;
  windowSize?: WindowSize;
  disableDroppable?: boolean;
  isShowSummery?: boolean;
}

interface IStateToProps {
  users: IUsers;
  project: IProjectStore;
  // companyMember: ICompanyMember;
  dirtySet: number[];
  ownerOrSupport: boolean;
  isCompanyAdmin: boolean;
  isDarkMode: boolean;
}

type IComponentProps = IOwnProps & IStateToProps & WithTranslation;

interface IComponentStates {
  weight: number;
  verifyStatus: TaskStatus;
  showVerifyPopover: boolean;
  showWeightPopover: boolean;
  showProgressPopover: boolean;
  loading: boolean;
}

class TaskListView extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  static defaultProps = {
    active: false,
    showWeight: false,
    disableDroppable: false,
  };

  state = {
    showVerifyPopover: false,
    showWeightPopover: false,
    showProgressPopover: false,
    weight: this.props.task.weight,
    verifyStatus:
      this.props.task?.verifiers?.[this.props.thisUserId]?.status ||
      'notStarted',
    loading: false,
  };

  wrapper: React.RefObject<HTMLDivElement> = React.createRef();
  title: React.RefObject<HTMLSpanElement> = React.createRef();
  titleText: React.RefObject<HTMLSpanElement> = React.createRef();
  date: React.RefObject<HTMLDivElement> = React.createRef();
  projectMember?: IProjectMemberView = this.props?.project?.myMembership;
  permission = generateUserPermission(
    this.props.thisUserId,
    this.props.task,
    this.projectMember ? this.projectMember.canCreate : false,
    this.props.ownerOrSupport || false,
    this.projectMember ? this.projectMember.admin : false,
    this.props.isCompanyAdmin || false
  );

  handleChangeInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const value = e.target.value;
    const name = e.target.name;
    if (name === 'verifyStatus') {
      this.setState({ verifyStatus: value as TaskStatus });
    } else if (name === 'weight') {
      this.setState({ weight: Number(value) });
    }
  };

  handleClickOnVerify = () => {
    if (this.permission.edit) {
      this.setState((state) => ({
        showVerifyPopover: !state.showVerifyPopover,
      }));
    }
  };

  handleClickOnTask = (e: React.MouseEvent) => {
    const { isHomePage = false } = this.props;
    e.preventDefault();
    if (isHomePage) {
      this.props.onClickOnTask(e as any);
      return;
    }
    if (
      this.props.dirtySet.length > 0 &&
      !confirm(this.props.t('changesWillBeLost'))
    ) {
      return;
    }
    // const titleElement = this.title;
    // if (
    //   e.target !== this.wrapper.current &&
    //   e.target !== this.title.current &&
    //   !titleElement.current?.contains(e.target as any) &&
    //   e.target !== this.date.current
    // ) {
    //   return;
    // }
    this.props.onClickOnTask(
      this.props.task.id,
      'info',
      this.props.task.viewToken,
      e
    );
  };

  handleSaveVerifier = () => {
    this.setState({ showVerifyPopover: false });
    const verifier = this.props.task.verifiers?.[this.props.thisUserId];
    if (verifier) {
      verifier.status = this.state.verifyStatus;
      if (this.state.verifyStatus === 'complete') {
        verifier.progress = 100;
      } else if (
        this.state.verifyStatus === 'rejected' ||
        this.state.verifyStatus === 'notStarted'
      ) {
        verifier.progress = 0;
      } else if (this.state.verifyStatus === 'started') {
        verifier.progress = 1;
      }
      // this.props.onUpdateAssignment(verifier);
    }
  };

  handleClickOnWeight = () => {
    if (this.permission.edit) {
      this.setState({ showWeightPopover: !this.state.showWeightPopover });
    }
  };

  handleSaveWeight = () => {
    const newTask = taskManipulate.storeToServer(this.props.task, true);
    this.setState({ loading: true });
    newTask.weight = Number(this.state.weight);
    this.props.onUpdateTask(newTask);
    appDispatch(updateTask({ task: newTask })).then((_: any) => {
      this.setState({ showWeightPopover: false, loading: false });
    });
  };

  handleAssignmentUpdate = (
    assigneeId: number,
    progress: number,
    status: TaskStatus,
    progressDescription: string,
    fieldValues: { [key: string]: string }
  ) => {
    const relatedAssignment = this.props.task.assignee[assigneeId];
    if (relatedAssignment) {
      const newRelatedAssignment = cloneDeep(relatedAssignment);
      newRelatedAssignment.status = status;
      newRelatedAssignment.progress = progress;
      newRelatedAssignment.progressDescription = progressDescription;
      newRelatedAssignment.taskFieldValues = fieldValues;
      this.props?.onUpdateAssignment?.(newRelatedAssignment);
    }
  };

  handleShowVerify = (showVerifyPopover: boolean) => {
    this.setState({ showVerifyPopover });
  };

  handleTaskBadge = (fieldList: IField[]) => {
    const filteredList: IField[] = fieldList?.filter((field: IField) => {
      return field.options && field.value && field.value !== HiddenFieldValue;
    });
    const listedBadges = filteredList?.map((field?: IField) => {
      if (field?.options && field?.value && field?.value !== HiddenFieldValue)
        return {
          value: field.value,
          name: field.name,
        };
      else return null;
    });
    return listedBadges;
  };

  render() {
    const {
      task,
      active,
      template,
      companyId,
      projectId,
      // thisUserId,
      users,
      templateSelected,
      index,
      editable,
      project,
      windowSize = 'large',
      t,
      i18n,
      isHomePage = false,
      isShowSummery = false,
      disableDroppable,
    } = this.props;

    let totalProgress = 0;
    const badgeColorType =
      (task.mentions?.length || 0) > 0
        ? task.mentions[0].event.type === 'CommentEvent'
          ? orange
          : blue
        : lightGreenSolid;
    if (typeof task.mainProgress === 'number') {
      totalProgress = task.mainProgress;
    } else if (typeof task.secondaryProgress === 'number') {
      totalProgress = task.secondaryProgress;
    }
    // @ts-expect-error it's ok
    const overDueDate = task.dueDate! < moment().add('days', -1);
    const in24hours =
      !overDueDate &&
      // @ts-expect-error it's ok
      task.dueDate! < moment().add('days', +1) &&
      // @ts-expect-error it's ok
      task.dueDate! > moment().add('hours', -1);
    const projectPart =
      window.location.href.includes('/project/') && projectId
        ? `project/${projectId}/`
        : '';
    const taskLink = `/t/${companyId}/${projectPart}task/editor/${task.id}/info`;
    const isDeleted = task.deleteState; /*&& task.deleteState === 'Deleted'*/

    // const currentUserAssignment: IAssignmentView = task.assignee[thisUserId];
    // const currentUserAssignmentObj = currentUserAssignment
    //   ? currentUserAssignment
    //   : undefined;
    const splitDateAndTimeDuration = smartSplitDateAndTimeDuration(
      task.startDate,
      task.dueDate,
      task.dateAndTime
    );
    let draftMessage: string = '';
    let badgeColor: string = black;
    if (task.subTasksAreReadyToPublish) {
      badgeColor = green;
      draftMessage = taskMessages.readyPublishSubTask(
        task.readyToPublishSubTaskTitle,
        task.subTasksTitle
      );
    } else if (task.draft) {
      if (task.taskIsReadyToPublish) {
        badgeColor = green;
        draftMessage = taskMessages.readyPublishTask(
          task.readyToPublishTaskTitle,
          task.taskName
        );
      } else {
        badgeColor = '#e56a6a';
        draftMessage = t('draft', { ns: 'taskManager' });
      }
    }
    if (task.deleteState) {
      badgeColor = red;
    }
    const canChangeSelfProgress = this.permission.markSelf && !task.draft;

    const hasParents = task?.includeParentTaskNames?.length;
    let parentNameList: string[] = [];

    if (hasParents) {
      parentNameList = task?.includeParentTaskNames?.reduce(
        (acc: string[], parentInd: number) => {
          acc.push(
            task.parents?.[parentInd]?.taskName +
              ' : ' +
              task.parents?.[parentInd]?.title || ''
          );
          return acc;
        },
        []
      ) as string[];
    }

    const fieldInTitle = task?.fields
      ?.filter((el: IField) => el.configs?.includes('showInTitle'))
      ?.reduce((acc: string, el: IField) => {
        if (el?.value) {
          acc +=
            el.title + ':' + convertDigitToProperFormat(el?.value) + '<br />';
        }
        return acc;
      }, '');

    const taskWeightComponent = (
      <div
        style={
          {
            // position: 'relative',
            // display: 'flex',
            // alignItems: 'center',
          }
        }
      >
        <APopover
          arrow={true}
          curveBorder={true}
          disabled={!this.permission.edit}
          placement="right-start"
          show={this.state.showWeightPopover}
          onShowChange={(show) => this.setState({ showWeightPopover: show })}
          target={
            <div>
              {withTitle(
                <Badge color="black" radius={10}>
                  {convertDigitToProperFormat(task.weight)}
                </Badge>,
                t('taskWeight') +
                  ' : ' +
                  convertDigitToProperFormat(task.weight)
              )}
            </div>
          }
        >
          <div onClick={(e) => e.stopPropagation()}>
            <Input
              id="weight"
              type="number"
              step="any"
              min="0"
              name="weight"
              onChange={this.handleChangeInput}
              value={this.state.weight}
              label={t('taskWeight', { ns: 'taskManager' })}
              placeholder={t('taskWeight', { ns: 'taskManager' })}
            />
            <div style={{ textAlign: 'center' }}>
              <Button
                color="green"
                onClick={this.handleSaveWeight}
                loading={this.state.loading}
              >
                {t('save', { ns: 'taskManager' })}
              </Button>
            </div>
          </div>
        </APopover>
      </div>
    );

    const contentGenerator = (provided?: any) => {
      const assigneeValues = Object.values(task.assignee).reduce(
        (list: IUserOption[], value) => {
          const item: IUserOption = {
            userId: value.userId,
            name: users.map?.[value.userId]?.name || '',
            roles: [],
            progressDescription: value.progressDescription,
            progress: value.progress,
            optionType: 'user',
            status: value.status ? value.status : 'notStarted',
            relatedRoleId: value.properties?.roleId,
            relatedRoleName: value.properties?.roleName,
            assignmentId: value?.id,
          };
          list.push(item);
          return list;
        },
        []
      );
      const progressOrAssigneePart = (
        <>
          {this.props.showProgress ? (
            <React.Fragment>
              {typeof task.mainProgress === 'number' && (
                <APopover
                  arrow={true}
                  curveBorder={true}
                  trigger="hover"
                  placement="right"
                  target={
                    <Progress color={blue}>
                      {roundToDynamicFloating(task.mainProgress)}
                    </Progress>
                  }
                >
                  <div>
                    {messages.mainProgress(
                      template.templateReportOptions!.mainProgressTitle!
                    )}
                  </div>
                </APopover>
              )}
              {typeof task.secondaryProgress === 'number' && (
                <APopover
                  arrow={true}
                  curveBorder={true}
                  placement="left"
                  trigger="hover"
                  target={
                    <Progress color={black}>
                      {roundToDynamicFloating(task.secondaryProgress)}
                    </Progress>
                  }
                >
                  <div>
                    {messages.secondaryProgress(
                      template.templateReportOptions!.secondaryProgressTitle!
                    )}
                  </div>
                </APopover>
              )}
            </React.Fragment>
          ) : Object.keys(task.assignee || {}).length > 0 ? (
            <span style={{ width: '8rem' }}>
              <TaskUserList
                trigger="hover"
                type={task.type}
                onChangeProgress={this.handleAssignmentUpdate as any}
                task={task}
                canChangeProgress={
                  this.permission.mark && !task.lockMark && !task.draft
                }
                canChangeSelfProgress={canChangeSelfProgress}
                compact={true}
                showTaskFields={true}
                values={assigneeValues}
                disable={true}
              />
            </span>
          ) : (
            <span style={{ width: '8rem' }}></span>
          )}
        </>
      );

      const mentionPop = (
        <MentionPop
          mentions={task.mentions ?? []}
          companyId={companyId}
          projectId={projectId}
          placement={'top-start'}
          isHoverIcon={false}
        />
      );
      if (windowSize !== 'small') {
        return (
          <ItemContianer
            active={active}
            {...provided?.draggableProps}
            {...provided?.dragHandleProps}
            ref={provided?.innerRef}
            style={{ ...provided?.draggableProps.style }}
          >
            <BadgeItemWrapper
              active={active}
              badgeColorType={badgeColorType}
              isMentioned={(task.mentions?.length || 0) > 0}
            >
              {mentionPop}
            </BadgeItemWrapper>
            <ItemWrapper
              active={active ? active : false}
              draft={task.draft}
              dependencyNotMeet={
                !!task.relatedTasks?.find((it) => it.blocksProgress)
              }
              className="hover-area"
              isDark={this.props.isDarkMode}
            >
              <TaskItem active={active ? active : false} draft={task.draft}>
                <a href={taskLink} onClick={this.handleClickOnTask}>
                  <TaskItemBody ref={this.wrapper} id="wrapper">
                    <div
                      style={{
                        float: languageDirection() === 'rtl' ? 'left' : 'right',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        gap: '0.5rem',
                      }}
                    >
                      {!isHomePage && (
                        <BadgeGroup>
                          {windowSize === 'large'
                            ? task?.fields?.map((field: IField) => {
                                if (
                                  field.options &&
                                  field.value &&
                                  field.value !== HiddenFieldValue
                                ) {
                                  return withTitle(
                                    <TaskBadge
                                      key={`feild-${field.value}-${field.name}-${task.id}`}
                                      color={stringToColour(
                                        field.name,
                                        1,
                                        null,
                                        field.value
                                      )}
                                      size={5}
                                      style={{ marginInlineEnd: 0 }}
                                      radius={8}
                                    >
                                      <TaskBadgeContent>
                                        {field.value}
                                      </TaskBadgeContent>
                                    </TaskBadge>,
                                    field.title + ': ' + field.value
                                  );
                                }
                                return null;
                              })
                            : this.handleTaskBadge(task?.fields).map(
                                (value, index, array) => {
                                  if (index === 0)
                                    return (
                                      <TaskBadge
                                        key={`${task.id}-${index}-${value}`}
                                        size={5}
                                        style={{ marginInlineEnd: 0 }}
                                        radius={8}
                                        color={stringToColour(
                                          value!.name,
                                          1,
                                          null,
                                          value!.value
                                        )}
                                      >
                                        <TaskBadgeContent>
                                          {value!.value}
                                        </TaskBadgeContent>
                                      </TaskBadge>
                                    );
                                  else if (index === 1) {
                                    return withMutipleTitle(
                                      <TaskBadge
                                        key={index}
                                        size={3}
                                        style={{
                                          marginLeft: 0,
                                          backgroundColor: `${gray}`,
                                        }}
                                        radius={8}
                                      >
                                        <TaskBadgeContent>
                                          {i18n.language === 'fa'
                                            ? convertDigitToProperFormat(
                                                array.length - 1
                                              )
                                            : array.length - 1}
                                          +
                                        </TaskBadgeContent>
                                      </TaskBadge>,
                                      <TaskBadgePopOverTaskList>
                                        {array.slice(1).map((value, index) => {
                                          return (
                                            <TaskBadge
                                              key={index}
                                              size={5}
                                              style={{ marginInlineEnd: 0 }}
                                              radius={8}
                                              color={stringToColour(
                                                value!.name,
                                                1,
                                                null,
                                                value!.value
                                              )}
                                            >
                                              <TaskBadgeContent>
                                                {value!.value}
                                              </TaskBadgeContent>
                                            </TaskBadge>
                                          );
                                        })}
                                      </TaskBadgePopOverTaskList>
                                    );
                                  }
                                  return null;
                                }
                              )}
                          {task.haveWeight && taskWeightComponent}
                        </BadgeGroup>
                      )}
                      {!isHomePage && progressOrAssigneePart}
                      <div
                        style={{
                          width: '10rem',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: '0.5rem',
                        }}
                      >
                        <ProgressBar
                          count={totalProgress}
                          total={100}
                          color={`linear-gradient(to ${languageDirection() === 'rtl' ? 'right' : 'left'}, hsl(${totalProgress * 1.73}, 59%, 49%) 0%, var(--exact-white) 100%);`}
                        />
                        <div
                          style={{
                            width: '4rem',
                            textAlign: 'end',
                          }}
                        >
                          {i18n.language === 'fa'
                            ? `${convertNumbersToProperFormat(totalProgress, 0)}%`
                            : `${totalProgress.toFixed(0)}%`}
                        </div>
                      </div>
                      {
                        <DateContainer ref={this.date}>
                          {!splitDateAndTimeDuration.date.startsWith(
                            'Unknown'
                          ) && (
                            <span
                              style={{
                                marginInlineStart: '1rem',
                                cursor: 'text',
                                textAlign: 'start',
                                lineHeight: '1rem',
                                display: 'flex',
                                alignItems: 'center',
                                color: in24hours
                                  ? blue
                                  : overDueDate && !task?.draft
                                    ? gray
                                    : 'var(--black)',
                              }}
                            >
                              {splitDateAndTimeDuration.date}
                            </span>
                          )}
                          {splitDateAndTimeDuration.time && (
                            <span style={{ marginInlineStart: '10px' }}>
                              <Badge
                                color={
                                  in24hours
                                    ? 'blue'
                                    : overDueDate && !task?.draft
                                      ? 'lightGray'
                                      : 'var(--black)'
                                }
                              >
                                {splitDateAndTimeDuration.time}
                              </Badge>
                            </span>
                          )}
                        </DateContainer>
                      }
                    </div>
                    <div
                      style={{
                        display: 'inline-flex',
                        alignItems: 'flex-start',
                        flexDirection: 'column',
                      }}
                    >
                      <TaskTitle
                        ref={this.title}
                        deleted={isDeleted}
                        archived={task.archived || project?.archived}
                        draft={task?.draft}
                      >
                        {/* {currentUserAssignment && (
                        <GradientCircleProgressbar
                          width={40}
                          percentage={currentUserAssignment.progress + 70}
                          strokeWidth={4}
                          primaryColor={[`${blue}`, `${exactWhite}`]}
                          secondaryColor="#f0f0f0"
                          fontSize={'0'}
                        />
                      )} */}
                        {(!templateSelected ||
                          task.draft ||
                          task.archived ||
                          task.subTasksAreReadyToPublish) && (
                          <ChipContainer
                            style={{
                              color: badgeColor,
                              backgroundColor: 'transparent',
                              flexShrink: '0',
                            }}
                            selected={false}
                          >
                            {(!templateSelected ? task.taskName || '' : '') +
                              (!templateSelected ? ' | ' : '') +
                              draftMessage +
                              (task.archived
                                ? ' | ' + t('archived')
                                : project?.archived
                                  ? ' | ' + t('projectArchived')
                                  : '') +
                              (task.archived ? ' | ' + t('archived') : '') +
                              (task.deleteState ? ' | ' + t('deleted') : '')}
                          </ChipContainer>
                        )}

                        <TaskTitleText
                          ref={this.titleText}
                          allowedAttributes={{ span: ['style'] }}
                          allowedTags={['span']}
                          html={task.title}
                        />
                      </TaskTitle>
                      {hasParents ? (
                        <div className="flex items-center flex-5">
                          {parentNameList.map((el: string, indx: number) => (
                            <TaskTitleText
                              key={indx}
                              allowedAttributes={{ span: ['style'] }}
                              allowedTags={['span']}
                              html={el}
                            />
                          ))}
                        </div>
                      ) : (
                        <></>
                      )}
                      {fieldInTitle ? (
                        <div
                          className="flex items-center flex-5"
                          style={{ alignItems: 'flex-start' }}
                        >
                          <TaskTitleText
                            key={Math.random()}
                            allowedAttributes={{ span: ['style'] }}
                            allowedTags={['span']}
                            html={fieldInTitle}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </TaskItemBody>
                </a>
              </TaskItem>
            </ItemWrapper>
          </ItemContianer>
        );
      } else {
        return (
          <ItemContianer
            active={active ? active : false}
            {...provided?.draggableProps}
            {...provided?.dragHandleProps}
            ref={provided?.innerRef}
            style={{ ...provided?.draggableProps.style }}
          >
            <MiniBadgeItemWrapper
              active={active}
              badgeColorType={badgeColorType}
              isMentioned={(task.mentions?.length || 0 || 0) > 0}
              isDark={this.props.isDarkMode}
            >
              {mentionPop}
            </MiniBadgeItemWrapper>
            <MiniItemWrapper
              active={active ? active : false}
              draft={task.draft}
              hasBadge={true}
              dependencyNotMeet={
                !!task.relatedTasks?.find((it) => it.blocksProgress)
              }
              isShowSummery={isShowSummery}
            >
              <TaskItem
                active={active ? active : false}
                draft={task.draft}
                style={!isShowSummery ? { minHeight: '10rem' } : {}}
              >
                <a
                  href={taskLink}
                  onClick={this.handleClickOnTask}
                  style={{ flexGrow: 1 }}
                >
                  <MiniTaskItemBody
                    ref={this.wrapper}
                    id="wrapper"
                    isShowSummery={isShowSummery}
                  >
                    <MiniContentItem>
                      <MinDateContainer ref={this.date}>
                        {!splitDateAndTimeDuration.date.startsWith(
                          'Unknown'
                        ) && (
                          <span
                            style={{
                              cursor: 'text',
                              textAlign: 'start',
                              lineHeight: '1rem',
                              display: 'flex',
                              alignItems: 'center',
                              color: in24hours
                                ? blue
                                : overDueDate
                                  ? gray
                                  : 'var(--black)',
                            }}
                          >
                            {splitDateAndTimeDuration.date}
                          </span>
                        )}
                        {splitDateAndTimeDuration.time && (
                          <span>
                            <Badge
                              color={
                                in24hours
                                  ? 'blue'
                                  : overDueDate
                                    ? gray
                                    : 'var(--black)'
                              }
                            >
                              {splitDateAndTimeDuration.time}
                            </Badge>
                          </span>
                        )}
                      </MinDateContainer>
                      <div
                        style={{
                          flexGrow: 1,
                          display: 'flex',
                          flexDirection: 'row-reverse',
                        }}
                      >
                        <div
                          style={{
                            width: '10rem',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '0.5rem',
                          }}
                        >
                          <ProgressBar
                            count={totalProgress}
                            total={100}
                            color={`linear-gradient(to ${languageDirection() === 'rtl' ? 'right' : 'left'}, hsl(${totalProgress * 1.73}, 59%, 49%) 0%, ${exactWhite} 100%);`}
                          />
                          <div style={{ width: '4rem', textAlign: 'end' }}>
                            {i18n.language === 'fa'
                              ? `${convertNumbersToProperFormat(totalProgress, 0)}%`
                              : `${totalProgress.toFixed(0)}%`}
                          </div>
                        </div>
                      </div>
                    </MiniContentItem>
                    <MiniContentText>
                      <TaskTitle
                        ref={this.title}
                        deleted={isDeleted}
                        archived={task.archived || project?.archived}
                      >
                        {(!templateSelected ||
                          task.draft ||
                          task.archived ||
                          task.subTasksAreReadyToPublish) && (
                          <ChipContainer
                            style={{
                              color: badgeColor,
                              backgroundColor: 'transparent',
                              flexShrink: 0,
                            }}
                            selected={false}
                          >
                            {(!templateSelected ? task.taskName || '' : '') +
                              (!templateSelected ? ' | ' : '') +
                              draftMessage +
                              (task.archived
                                ? ' | ' + t('archived')
                                : project?.archived
                                  ? ' | ' + t('projectArchived')
                                  : '') +
                              (task.archived ? ' | ' + t('archived') : '') +
                              (task.deleteState ? ' | ' + t('deleted') : '')}
                          </ChipContainer>
                        )}
                        <TaskTitleText
                          ref={this.titleText}
                          allowedAttributes={{ span: ['style'] }}
                          allowedTags={['span']}
                          html={task.title}
                          style={{ width: '100%' }}
                        />
                      </TaskTitle>
                      {hasParents ? (
                        <div
                          className="flex items-center flex-5"
                          style={{ alignItems: 'flex-start' }}
                        >
                          {parentNameList.map((el: string, indx: number) => (
                            <TaskTitleText
                              key={indx}
                              allowedAttributes={{ span: ['style'] }}
                              allowedTags={['span']}
                              html={el}
                            />
                          ))}
                        </div>
                      ) : (
                        <></>
                      )}
                      {fieldInTitle ? (
                        <div
                          className="flex items-center flex-5"
                          style={{ alignItems: 'flex-start' }}
                        >
                          <TaskTitleText
                            key={Math.random()}
                            allowedAttributes={{ span: ['style'] }}
                            allowedTags={['span']}
                            html={fieldInTitle}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </MiniContentText>
                    {!isHomePage && (
                      <MiniContentItem noWrap={!isHomePage}>
                        {progressOrAssigneePart}
                        <BadgeGroup>
                          {/* for minimal view */}
                          {this.handleTaskBadge(task?.fields).map(
                            (value, index, array) => {
                              if (index === 0)
                                return (
                                  <TaskBadge
                                    key={index}
                                    size={5}
                                    style={{ marginInlineEnd: 0 }}
                                    radius={10}
                                    color={stringToColour(
                                      value!.name,
                                      1,
                                      null,
                                      value!.value
                                    )}
                                  >
                                    <TaskBadgeContent>
                                      {value!.value}
                                    </TaskBadgeContent>
                                  </TaskBadge>
                                );
                              else if (index === 1) {
                                return withMutipleTitle(
                                  <TaskBadge
                                    key={index}
                                    size={3}
                                    style={{
                                      marginInlineEnd: 0,
                                      backgroundColor: `${gray}`,
                                    }}
                                    radius={8}
                                  >
                                    <TaskBadgeContent>
                                      {i18n.language === 'fa'
                                        ? `${convertDigitToProperFormat(array.length - 1)} +`
                                        : `+ ${array.length - 1}`}
                                    </TaskBadgeContent>
                                  </TaskBadge>,
                                  <TaskBadgePopOverTaskList>
                                    {array.slice(1).map((value, index) => {
                                      return (
                                        <TaskBadge
                                          key={index}
                                          // size={5}
                                          style={{ marginInlineEnd: 0 }}
                                          radius={8}
                                          color={stringToColour(
                                            value!.name,
                                            1,
                                            null,
                                            value!.value
                                          )}
                                        >
                                          <TaskBadgeContent>
                                            {value!.value}
                                          </TaskBadgeContent>
                                        </TaskBadge>
                                      );
                                    })}
                                  </TaskBadgePopOverTaskList>
                                );
                              }
                              return null;
                            }
                          )}
                          {task.haveWeight && taskWeightComponent}
                        </BadgeGroup>
                      </MiniContentItem>
                    )}
                  </MiniTaskItemBody>
                </a>
              </TaskItem>
            </MiniItemWrapper>
          </ItemContianer>
        );
      }
    };

    if (disableDroppable || isHomePage) {
      return <div>{contentGenerator()}</div>;
    }

    return (
      <Draggable
        isDragDisabled={!editable}
        draggableId={task.id.toString()}
        index={index}
      >
        {contentGenerator}
      </Draggable>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const users = state.users;
  const project =
    state.companies.data[props.companyId!]?.projects?.[
      props.projectId || props.task.projectId
    ];
  // const companyMember =
  //   state.companies.data[props.companyId!]?.members?.[props.thisUserId];
  const dirtySet = state.tasks.dirty || [];
  const company = state.companies.data[Number(props.companyId)];
  const ownerOrSupport =
    !!company && isCompanyOwnerOrSupport(props.thisUser, company);
  const companyAdmin = !!company && isCompanyAdmin(props.thisUser, company);
  const isDarkMode = state.app.UI.themeMode === 'dark';
  return {
    users,
    // companyMember,
    project,
    dirtySet,
    ownerOrSupport,
    isCompanyAdmin: companyAdmin,
    isDarkMode,
  };
};

export default connect(mapStateToProps)(
  withTranslation('taskManager')(TaskListView)
);
